import { Card, message, Input } from 'antd';
import React from 'react';
import _ from 'lodash';
import { app, api } from 'xadmin';
import { Page, C, Loading } from 'xadmin-ui';
import { Model } from 'xadmin-model';

const UserBaseInfo = {
  'type': 'object',
  'name': 'user',
  'resource': 'user',
  'title': '个人资料',
  'idProp': '_id',
  'key': 'user',
  'properties': {
    'username': {
      'title': '用户名',
      'type': 'string',
      'field': {
        component:(props)=>{
          const { input } = props
          return <Input disabled={true} value={input.value}/>
        }
      }
    },
    'email': {
      'title': '邮件',
      'type': 'string',
      'format': 'email'
    }
  },
  'partialSave': true,
  'permission': { add: true, edit: true, view: true, delete: true },
  'form': [
    'username',
    'email'
  ]
}

const Profile = props => {
  const [ data, setData ] = React.useState(null)

  React.useEffect(() => {
    api({ name: 'core/auth/user' }).fetch('').then(({ json }) => {
      setData(json)
    })
  }, [])

  const saveSettings = (values) => {
    return api({ name: 'core/auth/user' }).fetch('', {
      method: 'PUT',
      body: JSON.stringify(_.omit(values, 'id'))
    })
      .then(() => message.success('保存个人设置成功'))
  }

  return (
    <Page title="个人设置">
      { data ? <Model schema={UserBaseInfo} modelKey="profile">
        <C is="Model.TabsForm" item={data} id={data.id} forceTabs mode="left" saveItem={saveSettings} schemaKey="user.schema" />
      </Model> : <Loading /> }
    </Page>
  )

}

export default Profile
